import { render, staticRenderFns } from "./PharmaciesItem.vue?vue&type=template&id=5065da5d"
import script from "./PharmaciesItem.vue?vue&type=script&lang=js"
export * from "./PharmaciesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports